export function removeDuplicates<T>(array: T[]) {
	const seen = new Set();
	return array?.filter((obj: T) => {
		const key = JSON.stringify(obj);

		if (!seen.has(key)) {
			seen.add(key);
			return true;
		}
		return false;
	});
}
